import React, { useState, useEffect } from "react";
import { HERO_SLIDES } from "../mock/mock";

const Hero = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % HERO_SLIDES.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[560px] md:h-[640px] overflow-hidden">
      {HERO_SLIDES.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center scale-105"
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f2740]/75 via-[#15324f]/60 to-[#0f2740]/80" />
        </div>
      ))}

      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block border-2 border-white/40 px-8 md:px-14 py-7 md:py-10 backdrop-blur-[2px]">
            <h1
              className="text-white text-2xl md:text-4xl lg:text-[44px] font-bold tracking-[0.04em] leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              GOUVERNANCE TI <span className="text-[#9bc3e6]">|</span> AGILITÉ{" "}
              <span className="text-[#9bc3e6]">|</span> PERFORMANCE
            </h1>
          </div>
          <p className="mt-7 text-white/85 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Cabinet de conseil spécialisé en gouvernance des technologies de l'information et en transformation agile.
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-3 z-10">
        {HERO_SLIDES.map((slide, i) => (
          <button
            key={`dot-${slide.id}`}
            onClick={() => setCurrent(i)}
            aria-label={`Diapositive ${i + 1}`}
            className={`h-[3px] transition-all duration-300 ${
              i === current ? "w-10 bg-white" : "w-6 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
